export default __webpack_public_path__ + "media/color/cdn-427bd639.svg";